import { Component } from '@angular/core';

@Component({
  selector: 'app-external-redirect',
  templateUrl: './external-redirect.component.html',
  styleUrls: ['./external-redirect.component.scss'],
  imports: []
})
export class ExternalRedirectComponent {
}
